import * as React from "react";
import { HeadProps } from "gatsby";
import { Layout } from "../../components/Layout";
import { DefaultHeaders } from "../../components/SEO/DefaultHeaders";
import { DefaultLanguageRedirect } from "../../components/common/redirect/DefaultLanguageRedirect";
import { EventTemplate } from "../../components/events/EventTemplate/EventTemplate";
import { avioboglietoInBianco } from "../../data/events/avioboglietto-in-bianco";
import { avioboglietoInBiancoImages } from "../../components/events/avioboglietto-in-bianco/images";
import { buildEventJsonLd } from "../../structured-data/events/buildEventJsonLd";

export default function Index() {
  return (
    <DefaultLanguageRedirect>
      <Layout>
        <EventTemplate
          event={avioboglietoInBianco}
          images={avioboglietoInBiancoImages}
        />
      </Layout>
    </DefaultLanguageRedirect>
  );
}

export const Head = ({
  pageContext: { intl },
  location: { pathname },
}: HeadProps<PageDataProps, PageContextType>) => {
  const lang = intl.language === "en" ? "en" : "it";
  const event = avioboglietoInBianco;
  return (
    <DefaultHeaders
      intl={intl}
      title={event.seo.title[lang]}
      description={event.seo.description[lang]}
      keywords={event.seo.keywords[lang]}
      ogTitle={event.title[lang]}
      ogDescription={event.seo.description[lang]}
      ogImage={event.seo.ogImage}
      pathname={pathname}
      jsonLd={JSON.stringify(buildEventJsonLd(event, lang))}
    />
  );
};
